import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { RequestStatus } from '../../../../../../common/enums/requestStatus';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { takeProcessAndAddConsult } from '../../../../../utils/takeProcessAndAddConsult';
import { RequestReadButtons } from '../../../../elements/carePathButtons/RequestReadButtons';
import { Component } from '../../../../elements/Component';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';

export function Osasc2V1RequestRead(props: ICustomControlRequestReadProps) {
    if (props.request.status !== RequestStatus.completed) {
        props.setHideCreateActions(true);
    }

    return <InnerOsasc2V1RequestRead {...props} />;
}

export class InnerOsasc2V1RequestRead extends Component<ICustomControlRequestReadProps, {}> {
    public async componentDidMount() {
        if (
            this.props.request.authorization &&
            this.props.request.authorization.canTakeProcess &&
            this.props.request.status === RequestStatus.requested &&
            this.props.addReport
        ) {
            await takeProcessAndAddConsult(this.props.request, this.props.reloadProcess, this.props.addReport);
        }
    }

    public render() {
        return (
            <>
                {!this.props.process.diagnosticReports.length && !!this.props.addReport && (
                    <ProcessContainer>
                        <ProcessItemHeader
                            date={this.props.process.dateSent || (this.props.request && this.props.request.dateSent)}
                            isFirstItem={this.props.isFirstItem}
                            isFirstProcess={this.props.itemState.isFirstProcess}
                            isItemOpen={this.props.itemState.isOpen}
                            onToggle={async (isOpened) => {
                                await this.props.updateItemState({ ...this.props.itemState, isOpen: isOpened });
                            }}
                            organizationName={this.props.process.requesterOrganization?.name}
                            practitionerName={
                                this.props.process.requesterPractitioner
                                    ? getDisplayName(this.props.process.requesterPractitioner)
                                    : undefined
                            }
                            process={this.props.process}
                            serviceType={this.props.process.serviceType}
                            title={getServiceLabel(this.props.process.code, 'request', this.props.process.name)}
                        />

                        <RequestReadButtons {...this.props} />
                    </ProcessContainer>
                )}
            </>
        );
    }
}
